import React from "react";
import DuplicateGroupTable from "./components/DuplicateGroupTable";

const DuplicateUsersTab = () => (
  <DuplicateGroupTable
    entityType="users"
    headingLabel="portal users"
    searchPlaceholder="Search by email / username / name"
  />
);

export default DuplicateUsersTab;
